import { Component, OnInit } from '@angular/core';
import { AngularFireDatabase, AngularFireList } from 'angularfire2/database';
import { Todo } from '../class/todo';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Dialog2Component } from './dialog2/dialog2.component';

@Component({
  selector: 'app-dashboad',
  templateUrl: './dashboad.component.html',
  styleUrls: ['./dashboad.component.css']
})
export class DashboadComponent implements OnInit {

  tiles = [
    {text: '今日', cols: 2, rows: 1, color: 'lightblue'},
    {text: '今月', cols: 2, rows: 1, color: 'lightgreen'},
    {text: '半年', cols: 2, rows: 1, color: 'lightpink'},
    {text: '今年', cols: 2, rows: 1, color: '#DDBDF1'},
    {text: 'いつか', cols: 4, rows: 1, color: 'bisque'},
  ];

  draggable = true;
  color: string;
  todos: Todo[];
  todosRef: AngularFireList<any>;
  Offset = { x: 0, y: 0 };

  constructor(
    private db: AngularFireDatabase,
    public dialog: MatDialog
  ) { 
    this.todosRef = this.db.list('todos');
  }

  ngOnInit() {
    this.todosRef.snapshotChanges()
    .subscribe(snapshots => {
      this.todos = snapshots.map(snapshot => {
        const values = snapshot.payload.val();
        return new Todo({ key: snapshot.payload.key, ...values });
      });
    });
  }

  onMoveEnd(event, key: string) {
    this.Offset.x = event.x;
    this.Offset.y = event.y;
    this.todosRef.update(key, {
      x: this.Offset.x,
      y: this.Offset.y
    })
  }

  set(x, y){
    return {"x":x,"y":y}
  }

  openDialog(todo): void {
    let dialogRef = this.dialog.open(Dialog2Component, {
      width: '30vw',
      data:　todo
    });
  }
}



// WEBPACK FOOTER //
// C:/Users/homePC/angular-comp/yarukami/src/app/dashboad/dashboad.component.ts